import React from "react";
import {
  AvCheckboxGroup,
  AvCheckbox,
  AvField,
} from "availity-reactstrap-validation";
import { Label } from "reactstrap";
import { useTranslation } from "react-i18next";

type CustomCheckboxGroupProps = {
  fieldName: string;
  label?: string;
  helperText?: string;
  options: string[];
  selected: string[];
  setSelected: (value: string[]) => void;
  otherText: string;
  setOtherText: (value: string) => void;
  error: string | null;
  setError: (val: string | null) => void;
  validate?: ((value: string) => Promise<boolean>) | undefined;
  handleFieldChange?: (e: any, value: string) => void;
};

export const CustomCheckboxGroup = ({
  fieldName,
  label,
  helperText: helperText,
  options,
  selected,
  setSelected,
  otherText,
  setOtherText,
  error,
  setError,
  validate,
  handleFieldChange,
}: CustomCheckboxGroupProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      {label && label.trim() !== "" && (
      <h3 className="mb-2">{label}</h3>
      )}
      {helperText && helperText.trim() !== "" && (
        <p className="subtext">
          {helperText}
        </p>
      )}
      <AvCheckboxGroup
        name={fieldName}
        value={selected}
        className="custom-checkbox-group"
        onChange={(_, vals) => {
          if (!vals) return;
          setSelected([...vals]);
          if (vals.length > 0)  {
            setError(null);
          }
        }}
      >
        {options.map((opt, idx) => (
          <div key={opt} className="custom-checkbox-input">
            <Label
              className="custom-checkbox-label"
              htmlFor={`${fieldName}_${idx}`}
            >
              <AvCheckbox
                id={`${fieldName}_${idx}`}
                key={opt}
                label={<span className="custom-checkbox-label-inside">{opt}</span>}
                value={opt}
              />
            </Label>
          </div>
        ))}
      </AvCheckboxGroup>

      {selected.includes("Other") && (
        <div className="mt-1">
          <AvField
            autoFocus
            type="text"
            name={`${fieldName}OtherOption`}
            value={otherText}
            onChange={(e) => {
              setOtherText(e.target.value);
              handleFieldChange?.(e, e.target.value);
            }}
            placeholder="Please describe…"
            validate={{
              required: { value: true, errorMessage: t("required_field") },
              async: validate,
            }}
          />
        </div>
      )}

      {error && <div className="text-danger mt-1">{error}</div>}
    </>
  );
};
